/*
 * Desktop results layout: a full-width Toolbar on top, then a two-column
 * row with the filter sidebar on the left and the results column on the
 * right (selected-filter chips, products, then the bottom toolbar).
 */
.layout {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 20px;
  font-family: Oxygen, sans-serif;
}

.main {
  min-width: 0;
}

/* Active-filter chips show above the grid on desktop; on mobile they live
   inside the filter drawer instead. */
@media (max-width: 767px) {
  .selectedFilters {
    display: none;
  }
}

@media (min-width: 768px) {
  .layout {
    flex-direction: row;
    align-items: flex-start;
  }

  .sidebar {
    flex: 0 0 240px;
    border: 1px solid #ddd;
  }

  .main {
    flex: 1 1 auto;
  }
}
